// extracted by mini-css-extract-plugin
export default {"shell":"DriverShell_shell__x98eq","page":"DriverShell_page__HuSOH"};